import React, { createContext, useContext, useEffect, useState } from "react";
import { BASE_URL } from "./BASE_URL";

const SocialLinksContext = createContext();

export const SocialLinksProvider = ({ children }) => {
  const [links, setLinks] = useState(null);
  const [loading, setLoading] = useState(true);

  async function fetchLinks() {
    try {
      const res = await fetch(`${BASE_URL}/social-links`);
      const json = await res.json();

      if (!json.error && json.data) {
        setLinks(json.data);
      }
    } catch (error) {
      console.error("SOCIAL LINKS FETCH ERROR:", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchLinks();
  }, []);

  return (
    <SocialLinksContext.Provider value={{ links, loading }}>
      {children}
    </SocialLinksContext.Provider>
  );
};

export const useSocialLinks = () => useContext(SocialLinksContext);
